import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CaissePrelevement } from '../models/caissePrelevement';
import { CaisseDepot } from '../models/caisseDepot';

@Injectable({ providedIn: 'root' })
export class BusinessAccountService {
  private host: string = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private authHeaders() {
    const token = localStorage.getItem('tokenConnectedUserWSU1234567GHTVB');
    return new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': token });
  }

  addUtilisateurBussnessAccount(data: any, username: string) {
    return this.http.post(this.host + "/business/" + username + "/add/bussness/account", data, { headers: this.authHeaders() });
  }

  getAllUtilisateurBaccount(username: string) {
    return this.http.get(this.host + "/business/" + username + "/list/bussness/account", { headers: this.authHeaders() });
  }

  UpdateUtilisateurBussnessAccount(formdata: any, id: any) {
    return this.http.post(this.host + "/business/" + id + "/update/bussness/account", formdata, { headers: this.authHeaders() });
  }

  removeBaccount(id: any) {
    return this.http.delete(this.host + "/business/remove/compte/affaire/" + id, { headers: this.authHeaders() });
  }

  maketransfertVersSoldeInitial(accountid: any) {
    return this.http.post(this.host + "/business/transfert/vers/solde/initial/" + accountid, null, { headers: this.authHeaders() });
  }

  getcompteBussinessSolde(baccountNumber: any) {
    return this.http.get(this.host + "/business/init/solde/compte/affaire/" + baccountNumber, { headers: this.authHeaders() });
  }

  updateCaisierInformation(id: any, idcaissier: any, formdata: any) {
    return this.http.post(this.host + "/business/change/caissier/information/" + id + "/" + idcaissier, formdata, { headers: this.authHeaders() });
  }
  saveCaissier(id: any, formdata: any) {
    return this.http.post(this.host + "/business/add/caissier/to/account/" + id, formdata, { headers: this.authHeaders() });
  }

  getCaissiers(accountid: any) {
    return this.http.get(this.host + "/business/afficher/caissiers/" + accountid, { headers: this.authHeaders() });
  }


  prelevementCompteclient(payload: CaissePrelevement) {
    console.log("Payload Service Caissier************************:", payload);
    return this.http.post(this.host + "/business/caissier/prelever/somme/achat/du/compte/client", payload, { headers: this.authHeaders() });
  }

  depotClient(depotClient: CaisseDepot) {
    console.log("Payload Service Caissier************************:", depotClient);
    return this.http.post(this.host + "/business/caissier/depot/sur/compte/client", depotClient, { headers: this.authHeaders() });
  }

  retraitClient(formdata: any, username: any, accountid: any) {
    return this.http.post(this.host + "/business/caissier/retrait/sur/compte/client/" + username + "/" + accountid, formdata, { headers: this.authHeaders() });
  }

  getAccountInformation(account: any) {
    return this.http.get(this.host + "/business/caissier/account/information/" + account, { headers: this.authHeaders() });
  }
  getcompteBussiness(accountid: any) {
    return this.http.get(this.host + "/business/caissier/account/affaire/" + accountid, { headers: this.authHeaders() });
  }

  getPendingClientOperationConfirmations() {
    return this.http.get<any[]>(this.host + "/business/client/operation/confirmations/pending", { headers: this.authHeaders() });
  }

  decideClientOperationConfirmation(confirmationId: number, approve: boolean) {
    return this.http.post<number>(
      this.host + "/business/client/operation/confirmations/" + confirmationId + "/decision",
      { approve },
      { headers: this.authHeaders() }
    );
  }

}

